import gql from 'graphql-tag';

export type ConnectUserMutationVariables = {
  input: {
    data: {
      type: 'social_connection';
      attributes: {
        access_token: string;
        provider: string;
      };
    };
  };
};

export type DisconnectUserMutationVariables = {
  input: {
    data: {
      type: 'social_connection';
      attributes: {
        provider: string;
      };
    };
  };
};

export type ConnectUserMutation = {
  connectUser: {
    __typename: 'ConnectUser';
    data: {
      __typename: 'ConnectUserData';
      attributes: {
        __typename: 'ConnectUserAttributes';
        isAmazonConnected: boolean;
        isFacebookConnected: boolean;
      };
    };
  };
};

export type DisconnectUserMutation = {
  disconnectUser: {
    __typename: 'DisconnectUser';
    data: {
      __typename: 'DisconnectUserData';
      attributes: {
        __typename: 'DisconnectUserAttributes';
        isAmazonConnected: boolean;
        isFacebookConnected: boolean;
      };
    };
  };
};

const CONNECT_USER_ATTRIBUTES_FRAGMENT = gql`
  fragment ConnectUserAttributesFragment on ConnectUserAttributes {
    isAmazonConnected: is_amazon_connected
    isFacebookConnected: is_facebook_connected
  }
`;

const CONNECT_USER_FRAGMENT = gql`
  fragment ConnectUserFragment on ConnectUserData {
    type
    attributes @type(name: "ConnectUserAttributes") {
      ...ConnectUserAttributesFragment
    }
  }
  ${CONNECT_USER_ATTRIBUTES_FRAGMENT}
`;

const DISCONNECT_USER_ATTRIBUTES_FRAGMENT = gql`
  fragment DisconnectUserAttributesFragment on DisconnectUserAttributes {
    isAmazonConnected: is_amazon_connected
    isFacebookConnected: is_facebook_connected
  }
`;

const DISCONNECT_USER_FRAGMENT = gql`
  fragment DisconnectUserFragment on DisconnectUserData {
    type
    attributes @type(name: "DisconnectUserAttributes") {
      ...DisconnectUserAttributesFragment
    }
  }
  ${DISCONNECT_USER_ATTRIBUTES_FRAGMENT}
`;

export const CONNECT_USER_MUTATION = gql`
  mutation ConnectSocialAccountMutation($input: UserMutationVariables) {
    connectUser(input: $input)
      @rest(type: "ConnectUser", endpoint: "user", path: "/connect", method: "POST") {
      data @type(name: "ConnectUserData") {
        ...ConnectUserFragment
      }
    }
  }
  ${CONNECT_USER_FRAGMENT}
`;

export const DISCONNECT_USER_MUTATION = gql`
  mutation DisconnectSocialAccountMutation($input: UserMutationVariables) {
    disconnectUser(input: $input)
      @rest(type: "DisconnectUser", endpoint: "user", path: "/disconnect", method: "POST") {
      data @type(name: "DisconnectUserData") {
        ...DisconnectUserFragment
      }
    }
  }
  ${DISCONNECT_USER_FRAGMENT}
`;
